import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
	Box,
	SwipeableDrawer,
	Fab,
	Grid,
	TableRow,
	TableCell,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faFileCsv,
	faFilePdf,
	faPrint,
} from "@fortawesome/free-solid-svg-icons";
import { styled } from "@mui/material/styles";
import { CSVLink } from "react-csv";
import { Global } from "@emotion/react";
import jsPDF from "jspdf";
import useStore from "../../store/store";
import billService from "../../services/bill";
import style from "../../utils/style";
import utils from "../../utils/utils";
import constants from "../../utils/constants";
import Button from "../../controls/Button";
import PageHeading from "../../components/PageHeading";
import AddBill from "../../components/AddBill";
import CustomTable from "../../components/Table";
import moment from "moment";

function BillDetails() {
	const [isOpen, setIsOpen] = useState(false);
	const [title, setTitle] = useState("");
	const [arr, setArr] = useState([]);
	const [isDone, setIsDone] = useState(true);

	const csvLinkRef = useRef();
	const navigate = useNavigate();
	const {
		token,
		setErrorMessage,
		setSuccessMessage,
		setIsLoading,
		isLoggedIn,
		company,
		setCurrObj,
	} = useStore((state) => state);

	const headers = [
		{
			title: "Product",
			key: "product",
			align: "left",
			formatter: (k) => k.product,
		},
		{
			title: "Bags",
			key: "count",
			align: "right",
			formatter: (k) => utils.formatToNumber(k.count),
		},
		{
			title: "Weight/Bag",
			key: "weightPerBag",
			align: "right",
			formatter: (k) => utils.formatToNumber(k.weightPerBag),
		},
		{
			title: "Total Weight",
			key: "totalWeight",
			align: "right",
			formatter: (k) => utils.formatToNumber(k.totalWeight),
		},
		{
			title: "Rate",
			key: "rate",
			align: "right",
			formatter: (k) => utils.formatToNumber(k.rate),
		},
		{
			title: "Price",
			key: "price",
			headerAlign: "center",
			align: "right",
			formatter: (k) => {
				return (
					<>
						{utils.formatToNumberFix2(k.price)}
						{k._id !== "_id" && (
							<ion-icon
								style={{
									color: "red",
									marginLeft: "10px",
									cursor: "pointer",
								}}
								name="trash-outline"
								onClick={() => deleteEntry(k._id)}
							></ion-icon>
						)}
					</>
				);
			},
		},
	];

	const FooterSumRow = () => (
		<TableRow style={{ height: 35, background: "#eee" }}>
			<TableCell style={{ fontWeight: 500 }}>Total</TableCell>
			<TableCell align="right" style={{ fontWeight: 500 }}>
				{utils.formatToNumber(arr.reduce((a, b) => a + b.count, 0))}
			</TableCell>
			<TableCell align="right" style={{ fontWeight: 500 }} colSpan={2}>
				{utils.formatToNumber(
					arr.reduce((a, b) => a + b.totalWeight, 0)
				)}
			</TableCell>
			<TableCell align="right" style={{ fontWeight: 500 }} colSpan={2}>
				{utils.formatToCurrency(
					arr.reduce((a, b) => a + b.price, 0),
					""
				)}
			</TableCell>
		</TableRow>
	);

	useEffect(() => {
		if (!isLoggedIn) navigate("/login");
		getDataById();
	}, []);

	const getDataById = () => {
		setIsLoading(true);
		setArr([]);
		let billId = window.location.href.split("id=").pop();
		billService.getById(token, billId).then((result) => {
			if (result.error) {
				setErrorMessage(result.error);
				setIsLoading(false);
				return;
			}
			setTitle(result.data.title);

			let data = result.data.arr;
			let sumOfWeight = data.reduce((a, b) => a + b.totalWeight, 0);
			let comission = (sumOfWeight / 100) * 2;
			data.push({
				_id: "_id",
				product: "Comission",
				count: "",
				weightPerBag: "",
				totalWeight: "",
				rate: "",
				price: comission,
			});
			setArr(data);

			setIsDone(true);
			setIsLoading(false);
		});
	};

	const toggleDrawer = () => setIsOpen(!isOpen);

	const Puller = styled(Box)(() => ({
		width: 30,
		height: 6,
		backgroundColor: "#ccc",
		borderRadius: 3,
		position: "absolute",
		top: 8,
		left: "calc(50% - 15px)",
	}));

	const deleteEntry = (id) => {
		setIsLoading(true);
		billService
			.deleteEntry(token, id)
			.then((res) => {
				if (res.error) {
					setErrorMessage(res.error);
					setIsLoading(false);
					return;
				}

				setSuccessMessage("Entry deleted successfully.");
				setIsOpen(false);
				setIsLoading(false);
				getDataById();
			})
			.catch((err) => {
				setErrorMessage(err.message);
			});
	};

	const getCsvData = () => {
		const headers = [
			{ label: "Product", key: "product" },
			{ label: "Bags", key: "count" },
			{ label: "Weight/Bag", key: "weightPerBag" },
			{ label: "Total Weight", key: "totalWeight" },
			{ label: "Rate per Mann (40kg)", key: "rate" },
			{ label: "Price", key: "price" },
		];

		const csvData = [
			headers.map((header) => header.label),
			...arr?.map((item) =>
				headers.map((header) =>
					!isNaN(item[header.key])
						? utils.formatToNumber(item[header.key], "")
						: item[header.key]
				)
			),
		];

		csvData.unshift([title]);
		let bagsSum = utils.formatToNumber(
			arr.reduce((a, b) => a + b.count, 0)
		);
		let weightSum = utils.formatToNumber(
			arr.reduce((a, b) => a + b.totalWeight, 0)
		);
		let priceSum = utils.formatToNumberFix2(
			arr.reduce((a, b) => a + b.price, 0)
		);
		csvData.push(["Total", bagsSum, "", weightSum, "", priceSum]);
		return csvData;
	};

	const handleExport = () => csvLinkRef.current.link.click();

	const createPdf = (isPrint) => {
		let bagsSum = arr.reduce((a, b) => a + b.count, 0);
		let weightSum = arr.reduce((a, b) => a + b.totalWeight, 0);
		let priceSum = arr.reduce((a, b) => a + b.price, 0);

		const columns = [
			"Product",
			"Bags",
			"Wieght Per Bag",
			"Total Weight",
			"Rate",
			"Price",
		];
		const rows = [
			...arr.map((bill) => [
				bill.product,
				utils.formatToNumber(bill.count),
				utils.formatToNumber(bill.weightPerBag),
				utils.formatToNumber(bill.totalWeight),
				utils.formatToNumber(bill.rate),
				utils.formatToNumberFix2(bill.price),
			]),
			[],
			[
				"Total",
				utils.formatToNumber(bagsSum, ""),
				"",
				utils.formatToNumber(weightSum, ""),
				"",
				utils.formatToNumberFix2(priceSum, ""),
			],
		];

		const doc = new jsPDF();

		let isFirstPage = true;
		doc.autoTable({
			head: [columns],
			body: rows,
			styles: {
				fontSize: 10,
				cellPadding: 1,
				halign: "right",
				overflow: "linebreak",
			},
			didDrawPage: (data) => {
				//body
				if (isFirstPage) {
					doc.setFillColor(constants.PRIMARY);
					doc.rect(0, 0, doc.internal.pageSize.getWidth(), 50, "F");
					doc.setTextColor(255, 255, 255);

					doc.setFontSize(20);
					doc.text(company.shopName || "", 20, 15);
					doc.setFontSize(16);
					doc.text(
						company.name || "",
						doc.internal.pageSize.getWidth() - 50,
						15
					);
					doc.setFontSize(12);
					doc.text(company.address || "", 20, 34);
					doc.text(company.description || "", 20, 40);
					doc.text(
						company.phone || "",
						doc.internal.pageSize.getWidth() - 50,
						22
					);
					doc.text(
						company.additionalPhone || "",
						doc.internal.pageSize.getWidth() - 50,
						27
					);

					doc.setFillColor(255, 255, 255);
					doc.setTextColor(0, 0, 0);
					doc.setFontSize(16);
					doc.text(title || "", 20, 60);
					doc.setFontSize(12);
					doc.text(
						moment().format("DD/MM/YYYY"),
						doc.internal.pageSize.getWidth() - 60,
						60
					);

					isFirstPage = false;
				}

				doc.setFontSize(12);
				var pageSize = doc.internal.pageSize;
				var pageHeight = pageSize.height
					? pageSize.height
					: pageSize.getHeight();

				// note & signature
				doc.setFillColor(255, 255, 255);
				doc.setTextColor(0, 0, 0);
				doc.rect(0, pageHeight - 36, pageSize.getWidth(), 20, "F");
				doc.text(
					`Note: ${company.note || ""}`,
					data.settings.margin.left,
					pageHeight - 26
				);
				doc.text(
					"Signature: _ _ _ _ _ _ _ _ _ _ _ _ _",
					doc.internal.pageSize.getWidth() - 80,
					pageHeight - 26
				);

				//footer
				doc.setFillColor(constants.PRIMARY);
				doc.rect(0, pageHeight - 16, pageSize.getWidth(), 16, "F");
				doc.setTextColor(255, 255, 255);
				doc.text(
					process.env.REACT_APP_NAME,
					data.settings.margin.left,
					pageHeight - 7
				);
				doc.text(
					`0328-7877378`,
					doc.internal.pageSize.getWidth() - 50,
					pageHeight - 7
				);
			},
			startY: 65,
		});

		if (isPrint) {
			doc.autoPrint();
			window.open(doc.output("bloburl"), "_blank");
		} else {
			doc.save(`${title}.pdf`);
		}
	};

	return (
		<>
			<Fab
				color="primary"
				aria-label="add"
				onClick={toggleDrawer}
				style={{ position: "fixed", right: 20, bottom: 80 }}
			>
				<Add />
			</Fab>

			<Global
				styles={{
					".MuiDrawer-root > .MuiPaper-root": {
						height: `calc(80%)`,
						overflow: "visible",
						borderTopLeftRadius: 10,
						borderTopRightRadius: 10,
					},
				}}
			/>

			<SwipeableDrawer
				anchor="bottom"
				open={isOpen}
				onClose={() => {
					setCurrObj(null);
					toggleDrawer();
				}}
				onOpen={toggleDrawer}
				swipeAreaWidth={56}
				disableSwipeToOpen={true}
				ModalProps={{
					keepMounted: true,
				}}
			>
				<Puller />

				<AddBill toggleDrawer={toggleDrawer} reload={getDataById} />
			</SwipeableDrawer>

			<Grid container sx={style.container}>
				<Grid item xs={9} sx={{ mb: 2 }}>
					<PageHeading text={title} />
				</Grid>

				{arr?.length > 0 && (
					<Grid
						item
						xs={3}
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "right",
							justifyContent: "flex-end",
						}}
					>
						<>
							<Button
								style={{
									margin: "-20px -10px 0 -10px",
								}}
								variant="text"
								text=""
								isShort={true}
								height={20}
								icon={<FontAwesomeIcon icon={faFileCsv} />}
								onClick={handleExport}
							></Button>

							<CSVLink
								ref={csvLinkRef}
								data={getCsvData()}
								filename={"trial-balance.csv"}
							></CSVLink>

							<Button
								style={{
									margin: "-20px -10px 0 -10px",
								}}
								variant="text"
								text=""
								isShort={true}
								height={20}
								icon={<FontAwesomeIcon icon={faFilePdf} />}
								onClick={() => createPdf(false)}
							></Button>

							<Button
								style={{
									margin: "-20px -10px 0 -10px",
								}}
								variant="text"
								text=""
								isShort={true}
								height={20}
								icon={<FontAwesomeIcon icon={faPrint} />}
								onClick={() => createPdf(true)}
							></Button>
						</>
					</Grid>
				)}

				<Grid item xs={12} id="table">
					{isDone && (
						<CustomTable
							arr={arr}
							headers={headers}
							isDone={isDone}
							showFooterSumRow={true}
							FooterSumRow={FooterSumRow}
							addPagination={false}
						/>
					)}
				</Grid>

				<Grid item xs={12}>
					<div style={{ height: "60px" }}></div>
				</Grid>
			</Grid>
		</>
	);
}

export default BillDetails;
